module.exports = __webpack_public_path__ + "img/index_title.19d660e4.png";